import $ from 'jquery';
import 'magnific-popup';

$(document).ready(function () {

    if ($('.gallery-image').length) {
        $('.gallery-image').magnificPopup({ type: 'image', gallery: { enabled: true } });
    }

    if ($('.image-link').length) {
        $('.image-link').magnificPopup({ type: 'image' });
    }

    if ($('.installatie-img').length) {
        $('.installatie-img').magnificPopup({
            type: 'image',
            gallery: { enabled: true },
        });
    }

    if ($('.acf-image-uploader.has-value .show-if-value.image-wrap').length) {
        // Pre-detect full-size URLs: probeer origineel, dan -scaled als fallback
        var pending = 0;
        var $uploaders = $('.acf-image-uploader.has-value');

        function resolveFullSrc($img, thumbSrc, callback) {
            var base = thumbSrc.replace(/-\d+x\d+(?=\.\w+$)/, '');
            var ext = base.match(/\.\w+$/)[0];
            var withoutExt = base.slice(0, -ext.length);
            var testImg = new Image();
            testImg.onload = function () {
                $img.attr('data-full-src', base);
                callback();
            };
            testImg.onerror = function () {
                // Origineel bestaat niet, probeer -scaled
                var scaledSrc = withoutExt + '-scaled' + ext;
                var testScaled = new Image();
                testScaled.onload = function () {
                    $img.attr('data-full-src', scaledSrc);
                    callback();
                };
                testScaled.onerror = function () {
                    // Geen van beide bestaat, gebruik origineel als fallback
                    $img.attr('data-full-src', base);
                    callback();
                };
                testScaled.src = scaledSrc;
            };
            testImg.src = base;
        }

        function initAcfPopup() {
            $('.acf-image-uploader.has-value .show-if-value.image-wrap').magnificPopup({
                delegate: 'img',
                type: 'image',
                gallery: { enabled: true },
                callbacks: {
                    elementParse: function (item) {
                        item.src = item.el.attr('data-full-src') || item.el.attr('src').replace(/-\d+x\d+(?=\.\w+$)/, '');
                    },
                },
            });
        }

        $uploaders.each(function () {
            var $img = $(this).find('img[data-name="image"]');
            var src = $img.attr('src');
            if (src && /-\d+x\d+\.\w+$/.test(src)) {
                pending++;
                resolveFullSrc($img, src, function () {
                    pending--;
                    if (pending === 0) initAcfPopup();
                });
            }
        });

        // Als er geen thumbnails te resolven zijn, direct initialiseren
        if (pending === 0) initAcfPopup();
    }
});
